import {
    createLazyComponent,
    LazyModule,
    registerLazyOrchestrator,
    LazyImport,
    LazyAction,
} from 'owa-bundling';
import { resetSearchStore } from 'owa-search-actions/lib/actions/resetSearchStore';
import { invoke3sSearchForTab } from './actions/invoke3sSearchForTab';

export const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TabbedSearch"*/ './lazyIndex')
);

// Export interfaces and enums
export { SearchTab, TabbedSearchLoadingState } from './store/TabbedSearchStore';
export type { default as TabbedSearchStore } from './store/TabbedSearchStore';

// Export lazy selectors
export const lazyGetShouldShowTabbedSearch = new LazyImport(
    lazyModule,
    m => m.getShouldShowTabbedSearch
);

// Export lazy actions
export const lazySetLoadingState = new LazyAction(lazyModule, m => m.setLoadingState);
export const lazyResetTabbedSearchResults = new LazyAction(
    lazyModule,
    m => m.resetTabbedSearchResults
);
export const lazySetActiveSearchTab = new LazyAction(lazyModule, m => m.setActiveSearchTab);
export const lazyInvoke3sSearchForTab = new LazyAction(lazyModule, m => m.invoke3sSearchForTab);

// Export lazy components
export const TabbedSearchPivot = createLazyComponent(lazyModule, m => m.TabbedSearchPivot);
export const TabbedSearchPane = createLazyComponent(lazyModule, m => m.TabbedSearchPane);

// Register lazy orchestrator
registerLazyOrchestrator(resetSearchStore, lazyModule, m => m.resetSearchStoreOrchestrator);
registerLazyOrchestrator(invoke3sSearchForTab, lazyModule, m => m.invoke3sSearchForTabOrchestrator);
